import { memo } from 'react'
import cn from 'classnames'

import type { SpacerProps } from './types'

import styles from './Spacer.module.scss'

/** Пустой отступ внутри VStack/HStack: фиксированный по шкале или растягивающийся. */
export const Spacer = memo(function Spacer(props: SpacerProps) {
  const { size = 'SMALL_L', grow = false } = props

  return <div className={cn(styles.root, grow ? styles.grow : styles[`size_${size}`])} />
})
